import { Avatar, Link } from "@mui/material";
import {
  FC,
  useState,
  MouseEvent,
  ChangeEvent,
  useEffect,
  useMemo,
} from "react";
import { getClubs } from "../../api/clubs/club.api";
import {
  ClubType,
  IClubColumns,
  IClubData,
} from "../../common/interfaces/club.interface";
import { DataTable } from "../../components/tables/DataTable";
import useFuse from "../../hooks/useFuse";
import clubAvatar from "../../assets/clubAvatar.png";
import { useNavigate } from "react-router";
import { PLATFORM_CLUBS } from "../../common/constants/routes.constants";
import { getClubType, getTrimmedPublicKey } from "../../utils/helpers";

const Clubs: FC = () => {
  const [page, setPage] = useState<number>(0);
  const [items, setItems] = useState<IClubData[]>([]);
  const [search, setSearch] = useState<string>("");
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const navigate = useNavigate();

  useEffect(() => {
    void getClubsTableInfo();
  }, []);

  const getClubsTableInfo = async () => {
    try {
      setItems(await getClubs());
    } catch (error) {}
  };

  const handlePageChange = (
    event: MouseEvent<HTMLButtonElement> | null,
    newPage: number
  ) => {
    setPage(newPage);
  };

  const onRowsPerPageChange = (event: ChangeEvent<HTMLInputElement>) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  const goToClubDetails = (value) => {
    navigate(`${PLATFORM_CLUBS}/${value.address}`);
  };

  const clubTableColumns: IClubColumns[] = useMemo(() => {
    return [
      {
        id: "imageUrl",
        label: "Avatar",
        minWidth: 100,
        format: (value) => {
          return (
            <Avatar
              src={value === "" ? clubAvatar : value}
              alt="Club avatar"
              style={{ backgroundColor: "transparent" }}
            />
          );
        },
      },
      {
        id: "name",
        label: "Name",
        minWidth: 170,
      },
      {
        id: "address",
        label: "Address",
        minWidth: 170,
        format: (value) => {
          return (
            <Link href={`${PLATFORM_CLUBS}/${value}`}>
              {getTrimmedPublicKey(value)}
            </Link>
          );
        },
      },
      {
        id: "owner",
        label: "Owner",
        minWidth: 120,
      },
      {
        id: "governanceType",
        label: "Type",
        minWidth: 100,
        format: (value: ClubType) => {
          return getClubType(value);
        },
      },
      {
        id: "createdAt",
        label: "Created at",
        minWidth: 150,
        format: (value) => {
          return new Date(value).toDateString();
        },
      },
    ];
  }, []);

  const options = {
    includeScore: true,
    threshold: 0.1,
    keys: clubTableColumns.map((col) => col.id),
  };

  const filteredList: IClubData[] = useFuse(items, search, options);

  const handleSearch = (value: string) => {
    setSearch(value);
  };

  return (
    <div>
      <div>
        <h2>Clubs page</h2>
        <DataTable
          page={page}
          rowsPerPage={rowsPerPage}
          items={filteredList}
          columns={clubTableColumns}
          itemsCount={items.length}
          onPageChange={handlePageChange}
          onSearch={handleSearch}
          onRowsPerPageChange={onRowsPerPageChange}
          onRowClick={goToClubDetails}
          hasSearch
        />
      </div>
    </div>
  );
};

export default Clubs;
